import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { OrderComponent } from "../../order-manager/order/order.component";
import { catchError, throwError } from "rxjs";
import { OrdersService } from "../../../services-otc/orders.service";
import { Router } from "@angular/router";

@Component({
    selector: "app-remove-order",
    templateUrl: "./remove-order.component.html",
    styleUrls: ["./remove-order.component.css"],
    standalone: false
})
export class RemoveOrderComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<OrderComponent>,
        private ordersService: OrdersService,
        private router: Router
    ) {}

    cancelClearingItems() {
        this.dialogRef.close();
    }
    deleteOrder() {

        this.ordersService
            .deleteOrderById(this.data.orderId)
            .pipe(
                catchError((error) => {
                    console.error(error);
                    this.dialogRef.close();
                    return throwError(() => error);
                })
            )
            .subscribe(() => {
                this.dialogRef.close();
                this.router.navigate(["/order-manager/my-orders"]);
            });
    }
}
